<template>
	<div class="bottomMsView" style="position: relative;">
		<div @click='moreEvent'
			:style='island?"background-color:rgba(244, 244, 244, 1);padding: .5rem;z-index:101":"padding: .5rem"'>
			<a-badge :count="params.missionnum"
				:numberStyle="{width:'0.8rem',height:'0.8rem',minWidth:'0.8rem',lineHeight:'0.8rem',padding:'0',fontSize:'0.5rem',top:'0.3rem'}">
				<img :src="params.missionflag==1 ? icon_renwu1 : icon_renwu" style="width:2rem;height:2rem;">
			</a-badge>
			<span class='renwufont'>任務</span>
		</div>
		<div v-show='island' id='MsViewid'>
			<div class='awrptitle'>
				<div class='hovercolor' style='display:inline-block'>
					<a-icon type="left" @click="searchEvent" v-if='params.missionflag==1' />
					<span v-else style='display:inline-block;width:15px;height:15px'> </span>
					<span @click="searchEvent" style='color:#000'>任務</span>
				</div>
				<a-icon type="reload" style='float:right;margin-right:14px' @click='getdata' class='hovercolor' />
			</div>
			<div style="padding: 0 10px;background-color: #fff;">
				<div  v-for='(val,index) in listdata'>
					<div class='gre-title' @click='val.sta = !val.sta'>
						{{val.name}}
						<a-icon type="down" class='icon-right hovercolor' :class='val.sta?"icon-right0":"icon-right1"' />
					</div>
					<div :style="{height: val.sta?'0px':2*val.child.length+'rem'}" class="warp_top">
						<div v-for='(item,ind) in val.child' class='wil-list warp_listjqy' @click="handleClick(item,item.ind)"
							:style='{color:staticadmin == item.ind?"#8763ee":arrcolor[ind]}'>
							 <img v-if='index==0&&ind==0' src="@/image/lea/xiujia.png" alt="" class='btnIcon'>
							  <img v-if='index==0&&ind==1' src="@/image/lea/waichu.png" alt="" class='btnIcon'>
							   <img v-if='index==0&&ind==2' src="@/image/lea/jiaban.png" alt="" class='btnIcon'>
							    <img v-if='index==0&&ind==3' src="@/image/lea/wenju.png" alt="" class='btnIcon'>
							{{item.status}}
							<a-badge :count="item.amount"
								:numberStyle="{width:'0.8rem',height:'0.8rem',minWidth:'0.8rem',lineHeight:'0.8rem',padding:'0',fontSize:'0.5rem',top: '-0.1rem',left: '.2rem'}">
							</a-badge>
							<span v-if='item.amount>99' style="position: relative;top: -8px;left: -4px;"> +</span>
							<a-icon type="right"
								style='position: absolute;top: 0.8rem;right: .6rem;margin: 0;font-size: 10px;' />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import icon_renwu from '@/image/icon_renwu.png';
	import icon_renwu1 from '@/image/icon_renwu1.png';
	export default {
		props: ['params','pasadate'],
		data() {
			return {
				staticadmin: '',
				icon_renwu,
				icon_renwu1,
				imgarr:['@/image/lea/xiujia.png','@/image/lea/waichu.png','@/image/lea/jiaban.png','@/image/lea/wenju.png'],
				arrcolor:['#3bc7a1','#ffa647','#349ce5','#f57575'],
				island: 0,
				listdata: [],
			}
		},
		watch: {
			pasadate:{
				deep:true,
				handler(){
					this.listdata = this.pasadate
				}
			}
		},
		mounted() {
			var $s = document.getElementById('MsViewid');
			$s.onclick = function(e) {
				e.preventDefault();
				//return false;//也可以
			}
		},
		methods: {
			getdata() {
				// 	this.$ajax({
				// 		method: 'post',
				// 		url: this.$api.getGroups,
				// 		data: {}

				// 	}).then(res => {
				// 		if (res.data.qmiscode == 1000) {
				// 			this.listdata = res.data.result
				// 		}
				// 	})
			},
			//彈出前操作
			moreEvent() {
				// this.getdata()	
				this.island = this.island ? 0 : 1
			},
			handleClick(val, ind) {
				this.staticadmin = ind
				this.$emit('child', val)
				this.island = 0
			},
			searchEvent() {
				this.$emit('child', 'back')
				this.island = 0
			},
			handleClick1() {}
		}
	}
</script>

<style land='scss'>
	#MsViewid{
		.btnIcon {
		    width: 0.84rem;
		    margin-right: 0.5rem;
		}
	}
	
	#MsViewid {
		position: absolute;
		top: 3rem;
		z-index: 100;
		right: 0;
		width: 300px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	}

	.awrptitle {
		font-size: 0.85rem !important;
		padding: .7rem;
		background-color: rgba(244, 244, 244, 1);
		color: rgb(51, 51, 51);
		overflow: hidden;
	}

	.renwufont {
		font-size: 0.85rem !important;
		margin-left: 0.85rem;
		font-weight: bold;
	}

	.hovercolor:hover {
		color: #8763ee !important;
		/* #1890ff */
		cursor: pointer;

	}

	.hovercolor>span:hover {
		color: #8763ee !important;
	}

	.warp_listjqy:hover {
		color: #8763ee !important;
	}
</style>
<style lang="scss" scoped>
	.icon-right {
		position: absolute;
		right: .6rem;
		top: .5rem;
		width: 1rem;
		transform-origin: center center;
		/*设置图片旋转的中心点为左下角*/
		transition: all 0.5s;
		/*设置旋转的过渡效果：所有都过渡 过渡所需时间为0.8秒*/
	}

	.icon-right1 {
		transform: rotate(180deg);
		/*设置当鼠标经过盒子时第一个img的旋转角度为90°*/
	}

	.icon-right0 {
		transform: rotate(0deg);
		/*设置当鼠标经过盒子时第一个img的旋转角度恢复0°*/
	}

	.warp_top {
		transition: height .5s;
		-webkit-transition: height .5s;
		overflow: hidden;
	}

	.gre-title {
		position: relative;
		padding-left: 1.5rem;
	}

	.wil-list {
		position: relative;
		background-color: #fff;
		color: #000;
		padding-left: 3rem;
	}

	.wil-list-tit {
		background-color: #fff;
		color: #000;
		padding-left: 1.5rem;
	}

	.gre-title,
	.wil-list,
	.wil-list-tit {
		height: 2rem;
		line-height: 2rem;
		font-size: .8rem;
	}
</style>
